import React from "react";
import FaqSection from "./../../components/FaqSection";
import "./styles.scss";

function FaqPage(props) {
  return (
    <FaqSection
      color="white"
      size="medium"
      title="Frequently Asked Questions"
      subtitle="Level up your zero-waste journey"
    />
  );
}

export default FaqPage;
